<template>
  <div class="search-bar-container" :class="props.classCustom">
    <div class="search-form for-pc">
    <div class="search-content">
        <div class="search-content-location cursor-pointer" @click="showAreaModal()">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20" fill="none">
        <path
            d="M7 0C3.13 0 0 3.13 0 7C0 12.25 7 20 7 20C7 20 14 12.25 14 7C14 3.13 10.87 0 7 0ZM2 7C2 4.24 4.24 2 7 2C9.76 2 12 4.24 12 7C12 9.88 9.12 14.19 7 16.88C4.92 14.21 2 9.85 2 7Z"
            fill="#B4B4B4"
        />
        <path
            d="M7 9.5C8.38071 9.5 9.5 8.38071 9.5 7C9.5 5.61929 8.38071 4.5 7 4.5C5.61929 4.5 4.5 5.61929 4.5 7C4.5 8.38071 5.61929 9.5 7 9.5Z"
            fill="#B4B4B4"
        />
        </svg>
        <Field v-model="selectedAreaSummary" name="parentCategory" v-if="selectedAreas.length != 0"
            id="select-group-area" class="select-location select-bg text-[14px]" readonly
            placeholder="エリア・駅から探す" autocomplete="off" @click="showAreaModal()">
            <div class="all-search-data-section">
                <label v-for="(area, index) in selectedAreas" :key="index" class="rounded-xl bg-gray-200 ml-[5px] px-[10px] mr-1 selected-area-list">
                {{ area }}
                </label>
            </div>
        </Field>
        <div v-else class="opacity-50 selected-area-main-title cursor-pointer text-[14px]">エリア・駅から探す</div>
        </div>
        <div class="mr-[10px] cursor-pointer" @click="showAreaModal()">
            <svg width="14px" height="14px" viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg" transform="rotate(90 4 6)">
            <path class="lg:block" d="M1.70492 0L0.294922 1.41L4.87492 6L0.294922 10.59L1.70492 12L7.70492 6L1.70492 0Z" fill="#B4B4B4" />
          </svg>
        </div>
    </div>
        
      <div class="search-content search-content-calendar">
        <div class="search-calendar" @click="handleShowPopUp">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="20"
            viewBox="0 0 19 20"
            fill="none"
          >
            <path
              d="M16.5 2H15.5V0H13.5V2H5.5V0H3.5V2H2.5C1.39 2 0.51 2.9 0.51 4L0.5 18C0.5 19.1 1.39 20 2.5 20H16.5C17.6 20 18.5 19.1 18.5 18V4C18.5 2.9 17.6 2 16.5 2ZM16.5 18H2.5V8H16.5V18ZM16.5 6H2.5V4H16.5V6ZM14.5 11H9.5V16H14.5V11Z"
              fill="#B4B4B4"
            />
          </svg>
          <Field
            v-model="formResearch.dt"
            id="select-calendar"
            class="select-calendar text-[14px]"
            value=""
            placeholder="日時から探す"
            autocomplete="off"
          >
          </Field>
        </div>
        <button
          class="search-content-calendar-btn-reset"
          :class="{ active: formResearch.timeEnd != '' }"
          @click="handleRemoveDate"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <rect width="20" height="20" rx="10" fill="#D9D9D9" />
            <path
              d="M15.8334 5.34199L14.6584 4.16699L10.0001 8.82533L5.34175 4.16699L4.16675 5.34199L8.82508 10.0003L4.16675 14.6587L5.34175 15.8337L10.0001 11.1753L14.6584 15.8337L15.8334 14.6587L11.1751 10.0003L15.8334 5.34199Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
      <div class="search-content search-content-usage">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
                <path d="M14.63 0.84C14.27 0.33 13.67 0 13 0L2 0.0100002C0.9 0.0100002 0 0.9 0 2V12C0 13.1 0.9 13.99 2 13.99L13 14C13.67 14 14.27 13.67 14.63 13.16L19 7L14.63 0.84ZM13 12H2V2H13L16.55 7L13 12Z" fill="#B3B3B3"/>
            </svg>
            <Field v-model="selectedCategorySummary" name="parentCategory"
                id="selectParentCategory" class="select-location select-bg text-ellipsis cursor-pointer text-[14px]" readonly
                placeholder="利用用途から探す" autocomplete="off" @click="showPurposeOfUseModal()"></Field>
      </div>
      <div class="search-content search-content-people">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <path
            d="M20.5 21V19C20.5 17.9391 20.0786 16.9217 19.3284 16.1716C18.5783 15.4214 17.5609 15 16.5 15H8.5C7.43913 15 6.42172 15.4214 5.67157 16.1716C4.92143 16.9217 4.5 17.9391 4.5 19V21"
            stroke="#B3B3B3"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.5 11C14.7091 11 16.5 9.20914 16.5 7C16.5 4.79086 14.7091 3 12.5 3C10.2909 3 8.5 4.79086 8.5 7C8.5 9.20914 10.2909 11 12.5 11Z"
            stroke="#B3B3B3"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <select
          v-model="formResearch.pp"
          name="parentCategory"
          class="select-options text-[14px]"
          @change="onChangeSearchValue"
          :style="formResearch.pp == '' ? 'color: #B4B4B4;' : ''"
        >
          <option style="color: #222" value="">人数から探す</option>
          <option
            :value="item.id"
            v-for="(item, index) in listPeople"
            :key="index"
            style="color: #222"
          >
            {{ item.name }}
          </option>
        </select>
        <button class="mr-2.5">
          <svg width="14px" height="14px" viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg" transform="rotate(90 4 6)">
            <path class="hidden lg:block" d="M1.70492 0L0.294922 1.41L4.87492 6L0.294922 10.59L1.70492 12L7.70492 6L1.70492 0Z" fill="#B4B4B4" />
          </svg>
        </button>
      </div>
    </div>
    <div class="search-form for-sp" @click="handleShowSearchModal">
      <div class="search-modal">
        <i class="fa fa-search search-icon" aria-hidden="true"></i>
        <div
          clas="list_text_search"
          style="
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #222;
          "
        >
          <span
            style="color: #b4b4b4"
            v-if="
              formResearch.dt == '' &&
              formResearch.pp == '' &&
              formResearch.ctg == '' &&
              formResearch.ar == ''
            "
            >条件を絞って検索する</span
          >
          {{ [
                selectedAreas?.join(",") || '',
                formResearch?.dt || "",
                selectedCategorySummary || "",,
                formResearch.pp.length > 0 ? formResearch.pp + "人" : ""
            ].filter(Boolean).join("、") 
         }}
        </div>
      </div>
    </div>
    <SortSpace @handleSort="handleSort" :totalSpace="props.totalSpace" />
  </div>
  <SearchDialogArea
    :dialogApply="isShowDialog"
    :isHomePage="props.isHomePage"
    @closeModalApply="closeModalApply"
  />
  <v-dialog v-model="isShowModalCalendar" class="c-popup-calendar">
    <ModalSearchCalendar
      @handleCloseModal="handleCloseModal"
      @handleSelectFullDateTime="handleSelectFullDateTime"
      :dataPopup="dataPopup"
    />
  </v-dialog>
  <v-dialog v-model="isShowAreaModal">
    <ModalSearchArea
      @handleCloseAreaModal="handleCloseAreaModal"
      @applyAreaConditions="handleApplyArea"
      :allListArea="store.listGroupArea"
      :dataPopupArea="dataPopupArea"
      :selectedEmptyParents = "selectedEmptyParents"
    />
  </v-dialog>
  <v-dialog v-model="isShowPurposeOfUseModal">
    <ModalSearchPurposeOfUses 
      @handleClosePurposeOfUsesModal="handleClosePurposeOfUsesModal"
      @applyUsageConditions="handleAppliedUsage"
      :dataUsesPopup="dataUsesPopup"
      :allListCategory="allListCategory"
    />
  </v-dialog>
</template>

<script setup>
/* eslint-disable */
import { ref, reactive, defineProps, watch, onMounted, computed } from "vue";
import useStore from "@/client/store/Customer";
import ModalSearchCalendar from "@/client/components/SearchComponent/ModalSearchCalendar.vue";
import ModalSearchPurposeOfUses from "@/client/components/SearchComponent/ModalSearchPurposeOfUses.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { ROUTER_PATH, ROUTE_NAME } from "@/client/const";
import { useRouter, useRoute } from "vue-router";
import SortSpace from "@/client/components/SortSpace/SortSpace.vue";
import SearchDialogArea from "@/client/molecules/LayoutHome/SearchDialogArea.vue";
import useCustomer from "@/client/store/Customer";
import ModalSearchArea from "@/client/components/SearchComponent/ModalSearchArea.vue";
import { getListLocationApi } from "@/client/api";
import { filterQueryParams } from "@/client/const/search";
import { getAllListCategorySpaceApi } from "@/admin/api";
const store = useStore();
const isShowModalCalendar = ref(false);
const router = useRouter();
const route = useRoute();

const emit = defineEmits(["emitSort", "handleSearchCL"]);

const props = defineProps({
  researchValue: {
    type: Object,
    default: () => {
      return {
        ctg: "",
        pp: "",
        dt: "",
        ga: "",
        ar:"",
      };
    },
  },
  totalSpace: {
    type: Number,
  },
  classCustom: {
    type: String,
  },
  selectedAreaSummary: {
    type: String,
  },
  isHomePage: {
    type: Boolean,
    default: false,
  }
});

const paramResearch = ref({
  ctg: "",
  pp: "",
  dt: "",
  ss: "",
  ga: "",
  ar:"",
});

const formResearch = ref({
  ctg: "",
  pp: "",
  dt: "",
  ss: "",
  ga: "",
  ar:"",
});

const dataUsesPopup = ref({
  id: "",
});
const allListCategory = ref([]);
const dataPopupArea = ref({
    id: "",
});
 
const selectedAreas = ref([])

onMounted(async () => {
    formResearch.value.ctg = route.query?.ctg ?? "";
    try {
        const selectedIds = formResearch.value.ctg
        ? formResearch.value.ctg.split(',').map(id => Number(id))
        : [];
        const response = await getAllListCategorySpaceApi();
        allListCategory.value = response;
        const accordionData = response.data;
        const selectedParentCategories = [];
        const selectedChildCategories = [];
        
        accordionData.forEach(section => {
        if (selectedIds.length === 0) {
            if (!section.children || section.children.length === 0) return;
        }
        
        const allChildrenSelected = section.children.every(child =>
            selectedIds.includes(child.id)
        );

        if (selectedIds.includes(section.id) || allChildrenSelected) {
            selectedParentCategories.push({ id: section.id, name: section.name });
        } else {
            section.children.forEach(child => {
            if (selectedIds.includes(child.id)) {
                selectedChildCategories.push({ id: child.id, name: child.name });
            }
            });
        }
        });

        // Filter selected categories by matching their IDs with selectedIds
        const selectedParentNames = selectedParentCategories
        .filter(p => selectedIds.includes(p.id))
        .map(p => `${p.name}すべて`);
        
        const selectedChildNames = selectedChildCategories
        .filter(c => selectedIds.includes(c.id))
        .map(c => c.name);

        selectedCategorySummary.value = [...selectedParentNames, ...selectedChildNames].join(',');
    } catch (err) {
        console.error('Failed to fetch category data', err);
    }
  
    const allArea = await getListLocationApi();
    const areaList = allArea.data;
    const selectedAreaIds = route.query.ar?.split(',') || [];
    const matchedAreas = areaList?.filter(area => selectedAreaIds.includes(String(area.id)));
    const orderedAreas = selectedAreaIds
        .map(id => matchedAreas?.find(area => String(area.id) === id))
        .filter(area => area); 
    selectedAreaSummary.value = orderedAreas?.map(area => area.name).join(',');
    selectedAreas.value = selectedAreaSummary.value.split(',').filter(item => item != '');
    
    store.fetchListAreaByGroup();
    store.fetchListLocation();
    store.fetchListGroupArea();
    if (props?.researchValue) {
        formResearch.value = props.researchValue;
    }
  
});
watch(route, async() => {
  if (route.query) {
    formResearch.value.ga = route.query?.ga ?? "";
    formResearch.value.ctg = route.query?.ctg ?? "";
    formResearch.value.pp = route.query?.pp ?? "";
    formResearch.value.dt = formResearch.value?.dt ?? "";
    formResearch.value.ss = route.query?.ss ?? "";
    formResearch.value.ar = route.query?.ar ?? "";
  }
  if(formResearch.value.ctg) {
    try {
        const selectedIds = formResearch.value.ctg
        ? formResearch.value.ctg.split(',').map(id => Number(id))
        : [];
        const response = await getAllListCategorySpaceApi();
        allListCategory.value = response;
        const accordionData = response.data;
        const selectedParentCategories = [];
        const selectedChildCategories = [];
        
        accordionData.forEach(section => {
        if (selectedIds.length === 0) {
            if (!section.children || section.children.length === 0) return;
        }
        
        const allChildrenSelected = section.children.every(child =>
            selectedIds.includes(child.id)
        );

        if (selectedIds.includes(section.id) || allChildrenSelected) {
            selectedParentCategories.push({ id: section.id, name: section.name });
        } else {
            section.children.forEach(child => {
            if (selectedIds.includes(child.id)) {
                selectedChildCategories.push({ id: child.id, name: child.name });
            }
            });
        }
        });

        // Filter selected categories by matching their IDs with selectedIds
        const selectedParentNames = selectedParentCategories
        .filter(p => selectedIds.includes(p.id))
        .map(p => `${p.name}すべて`);
        
        const selectedChildNames = selectedChildCategories
        .filter(c => selectedIds.includes(c.id))
        .map(c => c.name);

        selectedCategorySummary.value = [...selectedParentNames, ...selectedChildNames].join(',');
    } catch (err) {
        console.error('Failed to fetch category data', err);
    }

  }
    if(route.query.ar) {
        const allArea = await getListLocationApi();
        const areaList = allArea.data;
        const selectedAreaIds = route.query.ar?.split(',') || [];
        const matchedAreas = areaList?.filter(area => selectedAreaIds.includes(String(area.id)));
        const orderedAreas = selectedAreaIds
                .map(id => matchedAreas?.find(area => String(area.id) === id))
                .filter(area => area); 
        selectedAreaSummary.value = orderedAreas?.map(area => area.name).join(',');
        selectedAreas.value = selectedAreaSummary.value.split(',').filter(item => item != '');
    } else {
        selectedAreas.value = [];
    }
});


const listPeople = reactive([
  { name: "ブース(個室)", id: "1-5" },
  { name: "〜20人", id: "6-20" },
  { name: "21〜40人", id: "21-40" },
  { name: "41〜60人", id: "41-60" },
  { name: "61〜100人", id: "61-100" },
  { name: "101人〜", id: "101-" },
]);

const listPeopleFormTo = [
  { id: "1-5", data: { from: 1, to: 5 } },
  { id: "6-20", data: { from: 6, to: 20 } },
  { id: "21-40", data: { from: 21, to: 40 } },
  { id: "41-60", data: { from: 41, to: 60 } },
  { id: "61-100", data: { from: 61, to: 100 } },
  { id: "101-", data: { case_person: 101 } },
];

const dataPopup = ref({
  date: "",
  timeStart: "",
  timeEnd: "",
});

const isShowAreaModal = ref(false);
const selectedAreaSummary = ref("");
const selectedEmptyParents = ref([]);
const handleApplyArea = (data) =>{
  const names = data.selectedAreaSummary.map(item => item.name);
  selectedAreaSummary.value = names.join(",");
  const allId = data.selectedAreaSummary.map(item => item.id);
  dataPopupArea.value.id = allId.join(",");
  formResearch.value.ar = allId.join(",");
  const cleanQuery = {
    ...route.query,
    ar: allId.join(","),
    gp: allId.length ? (data.selectedEmptyParents?.join(',') || undefined) : ''
  };

  router.push({
    path: route.path,
    query: filterQueryParams(cleanQuery)
  });  
}

const showAreaModal = () => {
  dataPopupArea.value.id = formResearch.value.ar;
  if (route.query.gp) {
    selectedEmptyParents.value = route.query.gp.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
  }else{
    selectedEmptyParents.value = [];
  }

  isShowAreaModal.value = true;
};
const handleCloseAreaModal = () => {
    isShowAreaModal.value = false;
};

const handleShowPopUp = () => {
  isShowModalCalendar.value = true;
  const valueInputSelectCalendar = document.getElementById("select-calendar").value;
  if (valueInputSelectCalendar && valueInputSelectCalendar !== "利用日時") {
    const obj = valueInputSelectCalendar.split(" ");
    const time = obj[1].split("～");
    dataPopup.value.date = obj[0].replaceAll("/", "-");
    dataPopup.value.timeEnd = time[1];
    dataPopup.value.timeStart = time[0];
  }
};

const handleRemoveDate = () => {
  const selectCalendar = document.querySelector("#select-calendar");
  const btnRevemoValueDate = document.querySelector(".search-content-calendar-btn-reset");
  btnRevemoValueDate.classList.remove("active");
  selectCalendar.value = "";
  formResearch.value.dt = "";

  const cleanQuery = {
    ...formResearch.value,
    gp: route?.query?.gp || "",
  }
  router.push({
    query: filterQueryParams(cleanQuery),
    replace: true,
  });
};
const handleCloseModal = () => {
  isShowModalCalendar.value = false;
};

const handleSelectFullDateTime = (data) => {
  formResearch.value.dt = data;
  onChangeSearchValue();
};

const isShowDialog = ref(false);
const handleShowSearchModal = () => {
  useCustomer.isShowModalSearch = true;
  isShowDialog.value = true;
};
const closeModalApply = () => {
  isShowDialog.value = false;
  useCustomer.isShowModalSearch = false;
};

const handleParams = () => {
  const cleanParams = Object.entries(formResearch.value).reduce((acc, [key, value]) => {
    if (value !== "" && value !== undefined && value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});

  paramResearch.value = cleanParams;
};

const onChangeSearchValue = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  
  if (formResearch.value.ctg && formResearch.value.ga) {
    const foundCategory = store.getListCategory.find(
      (element) => element.id == formResearch.value.ctg
    );
    const foundGroupArea = store.getListGroupArea.find(
      (element) => element.id == formResearch.value.ga
    );
    if(foundCategory) {
        foundCategory.value ? (formResearch.value.ctg = foundCategory.value) : "";
    }
    if(foundGroupArea) {
        foundGroupArea.value ? (formResearch.value.ga = foundGroupArea.value) : "";
    }
    handleParams();
    router.push({
      query: filterQueryParams({
        ...paramResearch.value,
        gp: route?.query?.gp || "",
      }),
      replace: true,
    });
    emit("handleSearchCL", formResearch.value);
  } else if (formResearch.value.ga) {
    const result = store.getListGroupArea.find((item) => {
      return formResearch.value?.ga == item.id;
    });
    if (result) {
      formResearch.value.ga = "";
    } else {
      formResearch.value.ga = "";
    }
    handleParams();
    router.push({
        query: filterQueryParams({
            ...paramResearch.value,
            gp: route?.query?.gp || "",
        }),
      replace: true,
    });
    emit("handleSearchCL", formResearch.value);
  }  else {
    handleParams();
    router.push({
        query: filterQueryParams({
            ...paramResearch.value,
            gp: route?.query?.gp || "",
        }),
      replace: true,
    });
    emit("handleSearchCL", formResearch.value);
    return;
  }
};

const handleSort = (data, valueSort) => {
  emit("emitSort", data, valueSort);
  formResearch.value.ss = valueSort || "";
    router.replace({
        path: route.path,
        query: {
          ...route.query,
          ss: valueSort || "",
        },
    });
};
    
    const isShowPurposeOfUseModal = ref(false);
    const showPurposeOfUseModal = () => {
    isShowPurposeOfUseModal.value = allListCategory.value?.data.length > 0;
    dataUsesPopup.value.id = formResearch.value.ctg;
    };
    const handleClosePurposeOfUsesModal = () => {
      isShowPurposeOfUseModal.value = false;
      router.push({
        query: filterQueryParams(formResearch.value),
        replace: true,
      });
    };
    const selectedCategorySummary = ref("");
    const handleAppliedUsage = (data) => {
        const parentLabels = data.parents.map(p => `${p.name}すべて`);
        const childLabels = data.children.map(c => c.name);

        selectedCategorySummary.value = [...parentLabels, ...childLabels].join(",");

        // Save category IDs (or slugs, depending on what your backend expects)
        const allCategoryIds = [
            ...data.parents.map(p => p.id),
            ...data.children.map(c => c.id)
        ];
        formResearch.value.ctg = allCategoryIds.join(","); // comma-separated string
    };
</script>

<style scoped lang="scss">
@import "./SearchBarArea.scss";
.list_text_search {
  display: flex;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
}
.search-content-location{
    display: flex;
    align-items: center;
    gap: 5px;
    width: 100%;
/* Track */
&::-webkit-scrollbar-track {
  background: transparent;
}
 
/* Handle */
&::-webkit-scrollbar-thumb {
  background: transparent;
}
 
/* Handle on hover */
&::-webkit-scrollbar-thumb:hover {
  background: transparent;
}
 
/* Horizontal Scrollbar */
&::-webkit-scrollbar:horizontal {
  height: 0px;
}
 
/* Horizontal Track */
&::-webkit-scrollbar-track:horizontal {
  background: transparent;
}
 
/* Horizontal Handle */
&::-webkit-scrollbar-thumb:horizontal {
  background: transparent;
}
 
/* Horizontal Handle on hover */
&::-webkit-scrollbar-thumb:horizontal:hover {
  background: transparent;
}
}
.selected-area-list{
    min-width: max-content;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    background-color: #F0F0F0;;
}
.selected-area-main-title{
    white-space: nowrap;
    width: 112px;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width:850px) {
        width: 50px;
    }
}

.all-search-data-section{
    display: flex;
    align-items: center;
    overflow-x: auto;
    max-width: 150px;
    @media (max-width:850px) {
        max-width: 50px;
    }
    &::-webkit-scrollbar {
        width: 2px !important;
        height: 2px;
    }
}
// .search-content-location{
//     max-width: 150px;
//     @media (min-width:850px) {
//         max-width: 118px;
//     }
//     // @media (max-width:790px) {
//     //     max-width: 120px;
//     // }
// }

</style>
